import React, { Component, useState, useRef, Fragment } from 'react'
import { useMount } from 'react-use'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Button, message, Select, Input, InputNumber } from 'antd'
import styles from './changeBalanceDialog.module.scss'

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

@Form.create()
class ChangeBalanceForm extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { submit } = this.props
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          errors.forEach(({ message: msg }) => {
            message.error(msg)
          })
        })

        return console.error(err)
      }

      submit(values)
    });
  }

  render() {
    const { typeList = [], tenant, worker } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Item
            {...formItemLayout}
            label="当前余额">
            {tenant ? tenant.balance?.toFixed(2) : worker?.balance?.toFixed(2)}元
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="变更类型"
            required>
            {getFieldDecorator('type', {
              initialValue: 'balance/adjust',
              rules: [
                {
                  required: true,
                  message: '请选择变更类型',
                },
              ],
            })(
              <Select placeholder="选择变更类型">
                {
                  typeList.map(item => (
                    <Select.Option
                      key={item.value}
                      value={item.value}>{item.name}</Select.Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="调整金额"
            required
            extra="* 注意，此处是需要加减的金额，而不是最终余额">
            {getFieldDecorator('amount', {
              rules: [
                {
                  required: true,
                  message: '请输入变更金额',
                },
              ],
            })(
              <InputNumber style={{ width: 120 }} placeholder="金额" />
            )}
            <span style={{ marginLeft: 5 }}>元</span>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="备注"
            required>
            {getFieldDecorator('desc', {
              rules: [
                {
                  required: true,
                  message: '请输入变更备注',
                },
              ],
            })(
              <Input.TextArea rows={3} placeholder="输入备注" />
            )}
          </Form.Item>
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">更改</Button>
          </div>
        </Form>
      </div>
    )
  }
}

const ChangeBalance = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={500}
    centered
    visible={isOpen}
    onCancel={hide}>
    <ChangeBalanceForm submit={submit} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'CHANGE_BALANCE_DIALOG',
})(ChangeBalance)
